import script from "./ModalSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSuccess.vue?vue&type=script&setup=true&lang=js"

import "./ModalSuccess.vue?vue&type=style&index=0&id=7633055e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7633055e"]])

export default __exports__